<template>
    <b-form-checkbox
        :button-variant="color"
        :button="button"
        :checked="checked"
        :class="['form-input-checkbox', {'placeholder-label': label === false }]"
        :disabled="disabled"
        :indeterminate="indeterminate"
        :inline="inline"
        :plain="plain"
        :required="required"
        :size="size"
        :state="state"
        :switch="this.switch"
        :unchecked-value="uncheckedValue"
        :value="value"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)"
    >
        <slot />
    </b-form-checkbox>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'

export default {
    components: { BFormCheckbox },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        }
    },
    created() {
        if (this.validator) {
            this.$validator = this.validator
        }
    },
    inject: {
        validator: {default: null, from: 'validator'}
    },
    model: {
        event: 'input',
        prop: 'checked',
    },
    props: {
        button: {type: Boolean},
        checked: {type: [Array, Boolean, String, Number, Object]},
        color: {type: String},
        disabled: {type: Boolean},
        indeterminate: {type: Boolean},
        inline: {type: Boolean},
        label: {type: [String, Boolean], default: ''},
        large: {type: Boolean},
        plain: {type: Boolean},
        required: {type: Boolean},
        small: {type: Boolean},
        state: {type: Boolean, default: null},
        switch: {type: Boolean},
        uncheckedValue: {type: [Array, Boolean, String, Number, Object], default: false},
        value: {type: [Array, Boolean, String, Number, Object], default: true},
    }
}
</script>